import moment from "moment";
import { ICreateCampaignSteps } from "src/Contexts/Campaign/CampaignContextTypes";
import { GetDateUSSemValue } from "src/shared/Utils/FormatDateBR";
import { handleGenerateUuid } from "src/shared/Utils/handleGenerateUuid";

export const handleExemplosCampaign = (
  type: string
): ICreateCampaignSteps[] => {
  const exemplo1 = (): ICreateCampaignSteps[] => [
    {
      id: handleGenerateUuid(),
      title: "Apresentação inicial",
      date: `${GetDateUSSemValue()}`,
      time: `${moment().add(30, "minutes").format("HH:mm")}`,
      message: [
        "Olá {{nome}}, tudo bem? Aqui é o [Colocar seu Nome], sou especialista em planos de saúde 🏥💼",
        `<p>Notei que você demonstrou interesse em algum momento, e estou passando pra avisar que temos condições especiais essa semana 💸</p>
        <p><br></p>
        Posso te mandar mais informações? 💬
        `,
      ],
      status: "PENDING",
    },
    {
      id: handleGenerateUuid(),
      title: "Lembrete com mais incentivo",
      date: `${moment().add(1, "day").format("YYYY-MM-DD")}`,
      time: `${moment().add(30, "minutes").format("HH:mm")}`,
      message: [
        "🔔 Passando aqui rapidinho pra te contar:",
        `<p>Ontem mesmo consegui ajudar o Sr. João a economizar mais de R$300 por mês com um plano top! 💰🔥</p>
        <p><br></p>
        <p>E o melhor: sem burocracia e com carência reduzida! 🙌📄</p>
        <p><br></p>
        Está tudo ainda disponível, mas só até sexta. Quer que eu veja o melhor pra você também? 😉
        `,
      ],
      status: "PENDING",
    },
    {
      id: handleGenerateUuid(),
      title: "Lembrete com mais incentivo",
      date: `${moment().add(2, "day").format("YYYY-MM-DD")}`,
      time: `${moment().add(30, "minutes").format("HH:mm")}`,
      message: [
        `Hoje é o último dia das condições especiais que comentei 🛑⏳ 
        <p>Depois disso, os valores voltam ao normal 😕</p>`,

        `<p>Ainda dá tempo de garantir um plano com ótimo custo-benefício, sem carência e com atendimento nacional 💼.</p>
        <p><br></p>
        <p>Só preciso de 2 min do seu tempo pra te mostrar 📞</p>
        <p>Posso te ligar rapidinho? 😊</p>
        `,
      ],
      status: "PENDING",
    },
  ];

  const exemploVoltaAsAulas = (): ICreateCampaignSteps[] => [
    {
      id: handleGenerateUuid(),
      title: "Vamos conhecer novos planos",
      date: GetDateUSSemValue(),
      time: `${moment().add(1, "hour").format("HH:mm")}`,
      message: [
        "📚 Vamos conhecer novos planos de saúde ? ",
        "<p>Que tal proteger sua família com um plano de saúde acessível e sem burocracia?</p><p>Tenho condições especiais pra você hoje!</p>",
      ],
      status: "PENDING",
    },
  ];

  switch (type) {
    case "EXEMPLO1":
      return exemplo1();

    case "EXEMPLO2":
      return exemploVoltaAsAulas();

    default:
      return [];
  }
};
